var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLenful2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 30,
    viewBox: "0 0 136 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.1998 19.4163L79.541 14.7575L84.1998 10.0986L88.6257 14.5245C88.6852 14.5848 88.7185 14.666 88.7185 14.7506C88.7185 14.8352 88.6852 14.9165 88.6257 14.9767L84.1998 19.4163Z",
    fill: "#A3B2D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5294 19.4163L81.8706 14.7575L86.5294 10.0986L89.1713 12.7432C89.4412 13.0138 89.6549 13.3352 89.7999 13.6888C89.9449 14.0424 90.0185 14.4212 90.0163 14.8034C90.0142 15.1856 89.9363 15.5636 89.7873 15.9155C89.6382 16.2675 89.4209 16.5864 89.148 16.8539L86.5294 19.4163Z",
    fill: "#E52328"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6511 0L65.8936 14.7575L80.6511 29.5151L83.0627 27.1034C83.6425 26.5227 83.9703 25.7372 83.9755 24.9167C83.9806 24.0961 83.6626 23.3066 83.0901 22.7187L75.3208 14.7575L83.0627 7.01565C83.3741 6.70318 83.6203 6.33195 83.7869 5.92353C83.9536 5.51511 84.0375 5.07764 84.0337 4.63653C84.0298 4.19543 83.9384 3.75948 83.7647 3.35401C83.5909 2.94854 83.3384 2.58164 83.0216 2.27461L80.6511 0Z",
    fill: "#A3B2D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7063 0L67.9487 14.7575L82.7063 29.5151L85.1179 27.1034C85.6976 26.5227 86.0255 25.7372 86.0306 24.9167C86.0358 24.0961 85.7177 23.3066 85.1453 22.7187L77.376 14.7575L85.1179 7.01565C85.4293 6.70318 85.6754 6.33195 85.8421 5.92353C86.0088 5.51511 86.0927 5.07764 86.0888 4.63653C86.085 4.19543 85.9936 3.75948 85.8198 3.35401C85.6461 2.94854 85.3935 2.58164 85.0768 2.27461L82.7063 0Z",
    fill: "#293381"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.63525H4.18747V20.78H19.8083V24.3906H2.65279C1.94983 24.391 1.27549 24.1122 0.778037 23.6155C0.280581 23.1188 0.000726484 22.4449 0 21.7419L0 7.63525Z",
    fill: "#0D0D0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7187 7.49805H21.7583V11.1676H41.7187V7.49805Z",
    fill: "#0D0D0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7187 20.7236H21.7583V24.3931H41.7187V20.7236Z",
    fill: "#0D0D0D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3572 14.1108H21.7583V17.7804H37.3572V14.1108Z",
    fill: "#0D0D0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8115 14.1108H21.7583V24.3932H25.8115V14.1108Z",
    fill: "#0D0D0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4137 19.2657L48.1667 12.942L48.1338 24.3904H43.9518C43.9464 21.7176 43.9413 19.0451 43.9368 16.3731C43.9368 15.0157 43.9368 13.6578 43.9368 12.2994C43.9368 11.1772 43.8272 9.95355 44.4164 8.94368C44.7066 8.46468 45.1321 8.08234 45.6393 7.84483C46.1465 7.60732 46.7127 7.52528 47.2665 7.60906C48.5148 7.82008 49.3616 8.79569 50.1961 9.6562L59.4521 19.0191C59.463 15.2043 59.4735 11.39 59.4836 7.57617H63.6669C63.6669 10.2481 63.6715 12.9206 63.6806 15.5935C63.6806 16.9514 63.6806 18.3093 63.6889 19.6672C63.6889 20.7894 63.7971 22.0131 63.2093 23.0229C62.919 23.5019 62.4935 23.8843 61.9863 24.1218C61.4791 24.3593 60.9129 24.4413 60.3592 24.3576C59.1095 24.1465 58.2641 23.1709 57.4296 22.309L54.4137 19.2657Z",
    fill: "#0D0D0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0806 7.63232H96.1077V20.736H109.875V7.63232H113.848V22.4022C113.848 22.8927 113.654 23.3631 113.307 23.7102C112.96 24.0573 112.49 24.2527 112 24.2534H93.9318C93.4408 24.2534 92.9699 24.0584 92.6228 23.7112C92.2756 23.364 92.0806 22.8932 92.0806 22.4022V7.63232Z",
    fill: "#0D0D0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.839 7.63232H119.613V20.7867H135.622V24.2534H115.839V7.63232Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLenful2);
export default __webpack_public_path__ + "static/media/lenful_2.71cf27afd86490304ac74aa9f686ab12.svg";
export { ForwardRef as ReactComponent };